import MessagesPage from './MessagesPage';
export default MessagesPage;
